/** Só os dígitos, no máximo 11 — o que o CPF é de fato. */
export const digitosDeCpf = (v: string) => v.replace(/\D/g, "").slice(0, 11);

/**
 * Máscara de CPF que funciona com valor PARCIAL, pra usar enquanto se digita.
 *
 * O `formatCpf` da listagem devolve o valor cru quando não há exatamente 11 dígitos — serve pra
 * exibir um CPF já salvo, mas num input controlado isso deixa a tela mentir: com 12 dígitos ele
 * mostrava o texto original, e com um valor herdado do modo "Estrangeiro" mostrava algo formatado
 * enquanto o estado guardava outra coisa. Aqui a exibição SEMPRE sai dos dígitos, então o que se vê
 * é exatamente o que vai ser enviado.
 */
export function mascaraDeCpf(v: string): string {
  const d = digitosDeCpf(v);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}
